export default __webpack_public_path__ + "static/media/sound-social.306f99b4.png";